import type { IAlertMessageConfirmDeleteAddressHappy } from "@/happyTheme/interfaces/dashboard/IAlertMessageConfirmDeleteAddressHappy"
import { ref, type Ref } from "vue"

export const alertMessageConfirmDeleteAddressHappyEmpty = {
    message: "",
    class: ""
}

export const alertMessageConfirmDeleteAddressHappy: Ref<IAlertMessageConfirmDeleteAddressHappy> = ref(alertMessageConfirmDeleteAddressHappyEmpty)